// extracted by mini-css-extract-plugin
export default {"component":"input-languages-component_component_FGCt5"};